import { useIsFocused } from "expo-router/react-navigation";
import { router } from 'expo-router';
import { useLayoutEffect } from 'react';

import { useNpoOnboarding } from '@/api/hooks/meHooks';
import {
  useGetNonProfitLightRatingQuestions,
  useUpdateNonProfitOrgLightRatingQuestions
} from '@/api/hooks/nonProfitOrgHooks';
import NpoLightRatingQuestionsForm from '@/components/forms/NpoLightRatingQuestionsForm';
import { useAuth } from '@/contexts/authContext';
import { useNpoLoginScreenState } from '@/contexts/npoLoginScreenStateContext';
import { LightRatingQuestionsData } from '@/lib/validations/NpoOnboardingSchema';
import { i18n } from '@/utils/i18n';

const LightRatingQuestions = () => {
  const { state: authState } = useAuth();
  const { setCurrentPage, completeOnboarding } = useNpoLoginScreenState();
  const { data: quesitonsOptions } = useGetNonProfitLightRatingQuestions();
  const { mutateAsync: onBoardingUpdate, isPending: onBoardingIsPending } = useNpoOnboarding(
    authState.signUpData?.loginEmail?.type ?? 'CHURCH'
  );
  const { mutateAsync: updateLightRatingQuestions, isPending: lightRatingQuestionsPending } =
    useUpdateNonProfitOrgLightRatingQuestions();

  const isFocused = useIsFocused();
  useLayoutEffect(() => {
    if (isFocused) setCurrentPage(14);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFocused]);

  const initialData = quesitonsOptions?.map((option) => ({ id: option.id, answer: null })) ?? [];

  const onSubmit = async (data: LightRatingQuestionsData) => {
    try {
      const mappedAnswers =
        data.questions.length > 0
          ? data.questions.map((question) => ({
              questionId: question.id,
              answer: question.answer === 'Yes' ? 'true' : question.answer === 'No' ? 'false' : null
            }))
          : initialData.map((question) => ({
              questionId: question.id,
              answer: null
            }));

      updateLightRatingQuestions(
        {
          npoId: authState.signUpData?.loginEmail?.npoId ?? '',
          answers: mappedAnswers
        },
        {
          onSuccess: () => {
            onBoardingUpdate(
              {
                preferenceId: authState.preferenceId ?? '',
                lightRatingQuestions: true
              },
              {
                onSuccess: () => {
                  completeOnboarding();
                  router.replace('/(app)/(bottomTabs)/profile/npoProfile/insights');
                }
              }
            );
          }
        }
      );
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <NpoLightRatingQuestionsForm
      initialData={initialData}
      questionOptions={quesitonsOptions ?? []}
      isLoading={onBoardingIsPending || lightRatingQuestionsPending}
      onSubmitTapped={onSubmit}
      submitLabel={i18n.t('sign_in.nonProfit.go_to_profile')}
    />
  );
};

export default LightRatingQuestions;
